import bind from 'memoize-bind';
import React, { PureComponent } from 'react';

import { KeyNavigation } from 'shared/components/utils/KeyNavigation';

const NAVIGATION_KEYS = ['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'];

interface CalendarNavigationProps {
  activeIndex: number;
  className?: string;
  numColumns: number;
  onIndexChange: (index: number) => void;
  onEscape?: () => void;
}

export class CalendarNavigation extends PureComponent<
  React.PropsWithChildren<CalendarNavigationProps>
> {
  getIndexableChildren() {
    const { children } = this.props;
    let indexableChildren = 0;

    React.Children.forEach(children, function (child) {
      if (!child.props.disabled) {
        indexableChildren = indexableChildren + 1;
      }
    } as any);

    return indexableChildren;
  }

  onKeyDown(event: React.KeyboardEvent<Element>) {
    const { numColumns, activeIndex, onIndexChange, onEscape } = this.props;
    const childrenCount = this.getIndexableChildren();

    if (NAVIGATION_KEYS.includes(event.key) && activeIndex === -1) {
      onIndexChange(0);
      return;
    }

    switch (event.key) {
      case 'ArrowRight':
        event.preventDefault();
        onIndexChange(Math.min(activeIndex + 1, childrenCount - 1));
        break;
      case 'ArrowLeft':
        event.preventDefault();
        onIndexChange(Math.max(activeIndex - 1, 0));
        break;
      case 'ArrowDown':
        event.preventDefault();
        onIndexChange(Math.min(activeIndex + numColumns, childrenCount - 1));
        break;
      case 'ArrowUp':
        event.preventDefault();
        onIndexChange(Math.max(activeIndex - numColumns, 0));
        break;
      case 'Escape':
        if (onEscape) {
          event.preventDefault();
          onEscape();
        }
        break;
      case 'Tab':
        onIndexChange(-1);
        event.stopPropagation();
        break;
    }
  }

  render() {
    const { activeIndex, className, onIndexChange, children } = this.props;

    return (
      <KeyNavigation
        activeIndex={activeIndex}
        className={className}
        onIndexChange={onIndexChange}
        onKeyDown={bind(this.onKeyDown, this)}
      >
        {children}
      </KeyNavigation>
    );
  }
}
